module.exports = __webpack_public_path__ + "static/img/item15.64edabe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/summit/item15.png
// module id = yORJ
// module chunks = 1